import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const schedulesGetActionDetailSlice = createSlice({
  name: 'schedulesGetActionDetail',
  initialState: { schedulesGetActionDetail: initialState },
  reducers: {
    getSchedulesDetailApi: (state, data) => {
      state.schedulesGetActionDetail = data.payload;
    },
  },
});

export const { getSchedulesDetailApi } = schedulesGetActionDetailSlice.actions;

export default schedulesGetActionDetailSlice.reducer;
